import { Box } from '@mui/material';
import React from 'react';
import type { CarouselItemContent } from '../../template/imageCarouselTypes';
import ImageCarouselSlideContentFields from './ImageCarouselSlideContentFields';
import ImageCarouselSlideVideoControls from './ImageCarouselSlideVideoControls';

interface ImageCarouselSlideFooterProps {
  index: number;
  item: CarouselItemContent;
  onToggleVideo: (isVideo: boolean) => void;
  onVideoURLChange: (url: string) => void;
  onOpenLibrary: () => void;
  onUpdateHeading: (value: string) => void;
  onUpdateText: (value: string) => void;
}

/** A slide's video toggle/controls plus its title and description fields. */
export default function ImageCarouselSlideFooter({
  index,
  item,
  onToggleVideo,
  onVideoURLChange,
  onOpenLibrary,
  onUpdateHeading,
  onUpdateText,
}: ImageCarouselSlideFooterProps) {
  return (
    <Box sx={{ p: 1.5, display: 'flex', flexDirection: 'column', gap: 1, flex: 1 }}>
      <ImageCarouselSlideVideoControls
        index={index}
        isVideo={!!item.isVideo}
        videoURL={item.videoURL?.url}
        onToggleVideo={onToggleVideo}
        onVideoURLChange={onVideoURLChange}
        onOpenLibrary={onOpenLibrary}
      />
      <ImageCarouselSlideContentFields
        index={index}
        item={item}
        onUpdateHeading={onUpdateHeading}
        onUpdateText={onUpdateText}
      />
    </Box>
  );
}
